module.exports = __webpack_public_path__ + "static/media/Flik3_index.c3ae3bcb.pdf";